import { SearchFilterInput } from "@thenounproject/lingo-core";
import { createAction } from "@redux/actions/actionCreators";

const [useAddQueryFilter, addQueryFilter] =
  createAction<SearchFilterInput>("search/addQueryFilter");

export default useAddQueryFilter;
export { addQueryFilter };
